import axios from "axios";
import config from "../config";
import { FormResponse } from "./ResponseModels/FormResponse";

export async function PostLogDownloadModel(
  uuid: string,
  datetime_downloaded: Date,
  template_name: string
) {
  let response = null;
  response = axios
    .post<FormResponse>(config.getLogDownloadEndpoint, {
      uuid: uuid,
      datetime_downloaded: datetime_downloaded,
      template_name: template_name,
    })
    .catch((e) => {
      console.error("There was an error!", e);
    });

  return response;
}
